import {styled} from "@mui/material/styles";
import {Paper} from "@mui/material";

export const ContentContainer = styled(Paper)(({theme}) => ({
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
}))